import { UserService } from 'src/app/services/user.service';
import { Component, OnInit } from '@angular/core';
import { MODAL, ModalService } from '../../services/modal.service';
import { Assistance } from 'src/app/model/assistance';
import { TranslateService } from '@ngx-translate/core';
import { GTM } from 'src/app/services/gtm.service';

@Component({
  selector: 'ng-hbm-bdi-assistance',
  templateUrl: './assistance.component.html'
})
export class AssistanceComponent implements OnInit {

  isLoading: boolean = false;
  beautifiedBom: any;
  flattenBom: any;
  assistances: Assistance[];
  chosenAssistances: Assistance[] = [];

  constructor(public modalService: ModalService, private userService: UserService, private translate: TranslateService, private gtm: GTM) {
    this.beautifiedBom = this.modalService.currentDatas.bom;
    this.flattenBom = this.modalService.currentDatas.flattenBom;
    this.chosenAssistances = this.userService.userDatas.assistances;
    if (!this.chosenAssistances) {
      this.chosenAssistances = [];
    }
  }

  async ngOnInit(): Promise<void> {
    this.gtm.trackEvent('click', 'assistance', 'open', {'project_amount': this.beautifiedBom.totalPrice.toFixed(2)});
    this.assistances = [
      {
        id: "1",
        type: this.translate.instant('popins.assistance.installation'),
        price: undefined,
        code: "installation"
      },
      {
        id: "2",
        type: this.translate.instant('popins.assistance.transportation'),
        price: undefined, code: "transportation"
      }
    ];
  }

  isConfirmDisabled(): boolean {
    if (this.chosenAssistances) {
      return this.chosenAssistances.some(c => c.price == undefined);
    }
    return false;
  }

  confirm() {
    this.gtm.trackEvent('click', 'assistance', 'close-confirm', this.getAssistances());
    this.userService.userDatas.assistances = this.chosenAssistances;
    this.modalService.display(MODAL.PRODUCTS_LIST, { bom: this.beautifiedBom, flattenBom: this.flattenBom });
  }

  cancel() {
    this.gtm.trackEvent('click', 'assistance', 'close-cancel', {'project_amount': this.beautifiedBom.totalPrice.toFixed(2)});
    this.modalService.display(MODAL.PRODUCTS_LIST, { bom: this.beautifiedBom, flattenBom: this.flattenBom });
  }

  /** Fonction déterminant si le service est sélectionné */
  isAssistanceSelected(id: string): boolean {
    return this.chosenAssistances.find(a => a.id === id) != undefined;
  }

  /** Fonction de sélection d'un service */
  selectAssistance(assistance: Assistance): void {
    if (this.chosenAssistances.find(a => a.id === assistance.id)) {
      this.chosenAssistances = this.chosenAssistances.filter(a => a.id !== assistance.id);
    } else {
      this.chosenAssistances.push(assistance);
    }
  }

  /** Fonction pour récupérer le prix d'un service */
  getAssistancePrice(id: string): number {
    const assistance = this.chosenAssistances.find(a => a.id === id);
    return assistance ? assistance.price : 0;
  }

  /** Fonction pour mettre à jour le prix */
  updatePrice(event: any, id: string): void {
    this.chosenAssistances.find(a => a.id === id).price = Number(event.target.value);
  }

  /** Fonction pour cocher le service */
  checkAssistance(id: string) {
    const checkbox: HTMLInputElement = document.getElementById(`title-${id}`) as HTMLInputElement;
    checkbox.checked = !this.isAssistanceSelected(id) ? true : checkbox.checked;
  }

  /** Fonction pour décocher le service */
  uncheckAssistance(id: string) {
    const checkbox: HTMLInputElement = document.getElementById(`title-${id}`) as HTMLInputElement;
    checkbox.checked = !this.isAssistanceSelected(id) ? false : checkbox.checked;
  }

  getAssistances() {
    let obj = {
      project_amount: this.beautifiedBom.totalPrice
    };
    for (const assistance of this.chosenAssistances) {
      obj[assistance.code] = assistance.price;
    }
    return obj;
  }
}
